import { createContext, useContext } from 'react';

/**
 * Optional portal target for popover-style content (Select, Popover, Tooltip).
 * When a theme-scoped surface (e.g. a `.dark` FormSheet drawer) provides a node
 * here, that content portals inside the scope and inherits its tokens instead of
 * rendering light against `document.body`. Null → Radix defaults to the body.
 */
export const PortalContainerContext = createContext<HTMLElement | null>(null);

export function usePortalContainer(): HTMLElement | null {
  return useContext(PortalContainerContext);
}
